import React from 'react';
import {
  Paper,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Typography
} from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

/**
 * Search and filter component for maintenance work orders
 */
const MaintenanceFilters = ({
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  priorityFilter,
  setPriorityFilter,
  typeFilter,
  setTypeFilter,
  aircraftFilter,
  setAircraftFilter,
  aircraft = [],
  maintenance,
  filteredMaintenance,
  hideStatusFilter = false
}) => {
  const handleClearFilters = () => {
    setSearchTerm('');
    if (!hideStatusFilter) setStatusFilter('ALL');
    setPriorityFilter('ALL');
    setTypeFilter('ALL');
    setAircraftFilter('ALL');
  };
  const hasActiveFilters = searchTerm !== '' || (!hideStatusFilter && statusFilter !== 'ALL') || priorityFilter !== 'ALL' || typeFilter !== 'ALL' || aircraftFilter !== 'ALL';

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by Work Order #, Title, or Aircraft..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Grid>
        {!hideStatusFilter && (
        <Grid item xs={12} sm={4} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Status</InputLabel>
            <Select
              value={statusFilter}
              label="Status"
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <MenuItem value="ALL">All Status</MenuItem>
              <MenuItem value="SCHEDULED">SCHEDULED</MenuItem>
              <MenuItem value="HOLD">HOLD</MenuItem>
              <MenuItem value="IN_PROGRESS">IN_PROGRESS</MenuItem>
              <MenuItem value="PARTS_PROCURED">PARTS_PROCURED</MenuItem>
              <MenuItem value="COMPLETED">COMPLETED</MenuItem>
              <MenuItem value="CANCELLED">CANCELLED</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        )}
        <Grid item xs={12} sm={4} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Priority</InputLabel>
            <Select
              value={priorityFilter}
              label="Priority"
              onChange={(e) => setPriorityFilter(e.target.value)}
            >
              <MenuItem value="ALL">All Priority</MenuItem>
              <MenuItem value="LOW">LOW</MenuItem>
              <MenuItem value="MEDIUM">MEDIUM</MenuItem>
              <MenuItem value="HIGH">HIGH</MenuItem>
              <MenuItem value="CRITICAL">CRITICAL</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Type</InputLabel>
            <Select
              value={typeFilter}
              label="Type"
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <MenuItem value="ALL">All Types</MenuItem>
              <MenuItem value="INSPECTION">INSPECTION</MenuItem>
              <MenuItem value="MAINTENANCE">MAINTENANCE</MenuItem>
              <MenuItem value="REPAIR">DEFECT</MenuItem>
              <MenuItem value="SCHEDULED">SCHEDULED</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Aircraft</InputLabel>
            <Select
              value={aircraftFilter}
              label="Aircraft"
              onChange={(e) => setAircraftFilter(e.target.value)}
            >
              <MenuItem value="ALL">All Aircraft</MenuItem>
              {aircraft.map((ac) => (
                <MenuItem key={ac._id} value={ac._id}>
                  {ac.registration || ac._id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={2}>
          <Button
            fullWidth
            variant="outlined"
            size="small"
            startIcon={<ClearIcon />}
            onClick={handleClearFilters}
            disabled={!hasActiveFilters}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
      {filteredMaintenance.length !== maintenance.length && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Showing {filteredMaintenance.length} of {maintenance.length} work orders
        </Typography>
      )}
    </Paper>
  );
};

export default MaintenanceFilters;
